import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GreenLink } from 'components/styled/green-link';
import { handleMailTo } from 'handlers/handle-mailto';
import { SubscribeModalBox } from 'components/styled/subcribe-modal-box';
import { CenteredModal } from 'components/styled/centered-modal';
import { Grid } from '@mui/material';

import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import styled from '@emotion/styled';
import { colors } from 'constants/colors';

const StyledTitle = styled(Typography)({
  lineHeight: '35px !important',
  fontSize: '28px !important',
  fontWeight: '900 !important',
  fontFamily: 'Avenir-Regular !important',
  fontStyle: 'normal !important',
  color: `${colors.default.info}!important`,
  textAlign: 'center',
});

const StyledContent = styled(Typography)({
  lineHeight: '24px !important',
  fontSize: '16px !important',
  fontWeight: '500 !important',
  fontFamily: 'Avenir-Regular !important',
  fontStyle: 'normal !important',
  color: `${colors.default.lightGrey}!important`,
  textAlign: 'center',
  padding: '0 33px',
});

const StyledAction = styled(Button)({
  textTransform: 'none',
  color: colors.default.info,
  margin: '12px 33px 20px 33px',
  borderRadius: 0,
  fontFamily: 'Avenir-Regular',
  fontWeight: 800,
  fontSize: '16px',
  lineHeight: '22px',
});

const StyledDivider = styled('div')({
  border: '1px solid #555',
  display: 'block',
  width: '100%',
  background: 'transparent',
});

interface ModalStayTunedProps {
  opened: boolean;
  onClose?: () => any;
}
const ModalStayTuned: FC<ModalStayTunedProps> = ({ opened, onClose }) => {
  const { t } = useTranslation();

  const handleRefresh = () => window.location.reload();

  return (
    <>
      <CenteredModal open={opened} onClose={onClose}>
        <SubscribeModalBox className="modal-confirm">
          <Grid
            display="flex"
            direction="column"
            gap="15px"
            paddingBottom="30px"
          >
            <StyledTitle variant="h2">
              {t('modals.headers.stay-tuned')}
            </StyledTitle>
            <StyledContent>
              {t('modals.texts.techincal-difficulty')}
            </StyledContent>

            <StyledContent>
              {t('modals.texts.if-you-need-help')}
              &nbsp;
              <GreenLink href="" onClick={handleMailTo}>
                {t('modals.texts.support-email')}
              </GreenLink>
            </StyledContent>
          </Grid>

          <StyledDivider />

          <StyledAction variant="text" color="inherit" onClick={handleRefresh}>
            {t('modals.buttons.try-again')}
          </StyledAction>
        </SubscribeModalBox>
      </CenteredModal>
    </>
  );
};

export default ModalStayTuned;
